import { useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';

const MIN_HEIGHT_PX = 180;
const MAX_HEIGHT_PX = 480;

export function UrlListTextarea({
  value,
  onChange,
  placeholder,
  readOnly,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  readOnly?: boolean;
}) {
  const ref = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    const next = Math.min(
      Math.max(el.scrollHeight, MIN_HEIGHT_PX),
      MAX_HEIGHT_PX,
    );
    el.style.height = `${next}px`;
  }, [value]);

  return (
    <Form.Control
      ref={ref}
      as="textarea"
      className="url-textarea url-textarea-auto mono"
      placeholder={placeholder}
      value={value}
      readOnly={readOnly}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
